import ko from "knockout";
import session from "flow/session/session";
import environment from "flow/configuration/environment";
import ProductSelector from "flow/init/ProductSelector";
import MyFlow from "flow/MyFlow";

export class UserContext {
    myFlow: MyFlow;
    userName = ko.observable<string>();
    description = ko.observable<string>();
    productName = ko.observable<string>();
    impersonatedUser = ko.observable();
    environmentDescription = ko.observable<string>();
    showProductSelector = ko.observable<boolean>();
    systemVersion = ko.observable<string>();

    logout(): void {
        session.logout();
    }

    changeProduct(): void {
        new ProductSelector(this.myFlow).reselect();
    }

    setup(myFlow: MyFlow): void {
        this.myFlow = myFlow;
        this.myFlow.envSubscribe(environment.keys.productName, this.productName, true);
        this.myFlow.envSubscribe(environment.keys.userName, this.userName, true);
        this.myFlow.envSubscribe(environment.keys.description, this.description, true);
        this.myFlow.envSubscribe(environment.keys.impersonating, this.impersonatedUser, true);
        this.myFlow.envSubscribe(environment.keys.showProductSelector, this.showProductSelector, true);

        this.myFlow.envSubscribe(environment.keys.environmentDescription, this.environmentDescription, true);
        this.myFlow.envSubscribe(environment.keys.systemVersion, this.systemVersion, true);
    }
}

const userContext = new UserContext();
export default userContext;
